// eslint-disable-next-line import/named
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";

interface QueryParams {
    v4?: string;
}

type OwnProps = RouteComponentProps<undefined, undefined, undefined, QueryParams>;

interface StateToProps {
    version: number;
    routerProps: OwnProps;
}

export function createMapStateToProps() {
    return (_state: Record<string, never>, ownProps: OwnProps): StateToProps => {
        return {
            version: ownProps.location.query.v4 === "true" ? 4 : 3,
            routerProps: ownProps
        };
    };
}

const chooseRegistrationFlowContainer = (
    component: React.ComponentType<never>
): React.ComponentClass<Pick<StateToProps, never> & OwnProps> => {
    return connect(
        createMapStateToProps(),
        null
    )(component);
};

export default chooseRegistrationFlowContainer;
